module.exports = __webpack_public_path__ + "img/belgium-transport-accidents-female.900b42df.png";